import { render, staticRenderFns } from "./sampleOrderStatistics.vue?vue&type=template&id=32a8c92e&scoped=true"
import script from "./sampleOrderStatistics.vue?vue&type=script&lang=js"
export * from "./sampleOrderStatistics.vue?vue&type=script&lang=js"
import style0 from "./sampleOrderStatistics.vue?vue&type=style&index=0&id=32a8c92e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8c92e",
  null
  
)

export default component.exports